import { motion } from "framer-motion";

const PORTRAIT = "https://customer-assets-7cd3h4nn.emergentagent.net/job_golden-wolf-premium/artifacts/0ag6fthu_WhatsApp%20Image%202026-09-01%20at%2021.43.26.jpeg";

const pillars = [
  { n: "01", h: "Third-generation Master Dog Trainer", b: "A lineage built inside the kennel — the craft has been in the Sanzone family for three generations." },
  { n: "02", h: "22+ years of professional experience", b: "Two decades in the field working with pets, working dogs, service dogs and their owners." },
  { n: "03", h: "4,000+ dogs trained", b: "Every temperament, every breed, every household — the pattern-recognition is real." },
  { n: "04", h: "Trained with & managed for Cesar Millan", b: "Direct experience learning inside and managing operations at one of the world's most recognized dog-training brands." },
  { n: "05", h: "Founder of Wolfkeeper University", b: "A formal school of the craft — the training method now trained the next generation of trainers." },
  { n: "06", h: "Obedience · Behavior · Service · Leadership", b: "One trainer, four disciplines. Rehab cases, service-dog task work, off-leash reliability, and owner-lifestyle training." },
  { n: "07", h: "Humane Society Trailblazer of the Year", b: "Recognized for advancing humane, force-considerate dog training and community programs." },
];

export default function WhyToriano() {
  return (
    <section className="section bg-ink" data-testid="why-toriano">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">Why Train With Toriano</div>
            <div className="hairline-gold mt-4 w-16" />
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.2rem,6vw,5.8rem)] leading-[0.95] tracking-[-0.02em]">
              The résumé is real.<br/>
              <span className="italic gold-foil">The results are visible.</span>
            </h2>
          </div>
        </div>
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden spotlight">
              <img src={PORTRAIT} alt="Toriano Sanzone" className="w-full h-full object-cover object-[center_15%]" />
              <div className="absolute inset-0 border border-gold/30"/>
              <div className="absolute top-4 left-4 text-hair text-gold z-10">Portrait · The Wolfkeeper</div>
            </div>
          </div>
          <div className="md:col-span-7 grid gap-3">
            {pillars.map((p, i) => (
              <motion.div key={p.n}
                initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.05 * i }}
                className="p-5 border border-hair hover:border-gold transition-colors bg-ink-2"
                data-testid={`why-${p.n}`}
              >
                <div className="flex items-start gap-4">
                  <div className="chapter-num text-2xl">{p.n}</div>
                  <div>
                    <div className="font-display italic text-xl md:text-2xl text-bone">{p.h}</div>
                    <p className="mt-1.5 text-sm text-bone/70">{p.b}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
